<template>
  <div>
    <v-dialog v-model="show" persistent max-width="500">
      <v-card>
        <v-card-title class="green white--text">
          {{
          isChangeArea ? $t('product.edit_product') : $t('area.add_area_stall')
          }}
        </v-card-title>
        <v-card-text class="py-5">
          <template v-if="!isChangeArea">
            <span>{{ $t('area.select_stall') }}</span>
            <AutocompleteArea
              v-model="form.area"
              :items="areaFilter || [obj]"
              :item-text="(item) => item.name"
              :item-value="(item) => item"
              :no-data-text="$t('area.no_empty_stall')"
              @input="productInArea"
              :label="$t('market.market_title')"
              outlined
            />
            <!-- <v-select
              color
              v-model="form.area"
              :items="areaFilter || [obj]"
              filled
              :item-text="(item) => item.name"
              :item-value="(item) => item"
              @change="productInArea"
              label="แผงค้า"
              solo
              flat
              background-color="grey lighten-4"
            ></v-select> -->
          </template>
          <span>{{ $t('product.select_product') }}</span>
          <v-autocomplete
            color
            v-model="form.products"
            :items="getProductNameOnly"
            :label="$t('product.title')"
            item-text="name"
            item-value="form"
            outlined
            multiple
            return-object
          >
            <template v-slot:append-outer>
              <v-icon v-if="admin || (employee && employee.enableAddProduct)" @click="isProduct = true">mdi-plus</v-icon>
              <v-tooltip v-else top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon disabled>mdi-plus</v-icon>
                  </div>
                </template>
                <span>{{ $t('product.no_permission_to_add_product') }}</span>
              </v-tooltip>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="show = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="saveArea" :disabled="!this.form.area">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form-product v-model="isProduct" @onLoad="loadInit" :event="`create`"></form-product>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormProduct from "./FormProduct.vue";
import AutocompleteArea from "./AutocompleteArea.vue";
export default {
  components: { FormProduct, AutocompleteArea },
  name: "FormAreaProduct",
  computed: {
    ...mapGetters({
      vacancyAreas: "area/getVacancyAreas",
      getProducts: "product/getProducts",
      getProductNameOnly: "product/getProductNameOnly"
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.$store.getters["markets/getMarketId"]);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.$store.getters["markets/getMarketId"]);
    },
    projects() {
      return this.getProducts;
    },
    areaFilter() {
      if (this.objectSelected) {
        const newArray = this.vacancyAreas
          ? this.vacancyAreas.filter(
              i =>
                !this.objectSelected.find(x => x.area.objectId == i.objectId) &&
                i
            )
          : [];

        return newArray;
      } else {
        return this.vacancyAreas;
      }
    },
    show: {
      get() {
        if (this.value) {
          this.loadInit();
          this.form = {
            area: {},
            products: []
          };
          if (this.obj) {
            this.form = {
              area: this.obj,
              products: this.obj.products
                ? this.obj.products.map(i => ({
                    objectId: i.objectId,
                    name: i.name
                  }))
                : []
            };
          }
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {},
  data() {
    return {
      form: {
        area: {},
        products: []
      },
      isProduct: false
    };
  },
  props: {
    value: Boolean,
    obj: Object,
    isChangeArea: Boolean,
    objectSelected: Array
  },
  methods: {
    async loadInit() {
      await this.$store.dispatch("area/getVacancyAreas");
      await this.$store.dispatch("product/getProducts", {
        projectId: this.$route.params.projectId
          ? this.$route.params.projectId
          : this.$store.getters["markets/getProjectId"]
      });
    },
    productInArea() {
      if (this.form.area.products) {
        this.form.products = this.form.area.products;
      }
    },
    saveArea() {
      if (this.isChangeArea) {
        this.$emit("onSaveEdit", this.form);
      } else {
        this.$emit("onSave", this.form);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
